import React from "react";
import styled from "styled-components";
import i18n from "i18next";
import { connect, ReactReduxContext } from "react-redux";
import { getAggregatorName } from "@kubera/common";

const Container = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 27px;
  font-feature-settings: "ss01" on;
`;

const Description = styled.div`
  margin-top: 2px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 150%;
  font-feature-settings: "ss01" on;
  color: #333333;
`;
const DescriptionMultipleWarning = styled.div`
  margin-top: 2px;
  margin-bottom: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 150%;
  font-feature-settings: "ss01" on;
  color: #333333;
`;

const ConnectionContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: ${props => (props.theme.mode === "dark" ? "#FFFFFF" : "transparent")};
`;

const ConnectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 14px 16px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:last-child {
    border-bottom: none;
  }
`;

const ConnectionContainerColumnItem = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
  color: rgba(0, 0, 0, 0.3);
`;

const ConnectionTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 150%;
  font-feature-settings: "ss01" on;
  color: #333333;
`;

const ConnectionDescription = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  font-feature-settings: "ss01" on;
  color: rgba(0, 0, 0, 0.5);
`;

const NewConnectionDescription = styled.div`
  margin-top: 2px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 120%;
  font-feature-settings: "ss01" on;
  color: rgba(0, 0, 0, 0.6);
`;

const NoteContainer = styled.div`
  margin-top: auto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
  font-feature-settings: "ss01" on;
  color: rgba(0, 0, 0, 0.5);

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

class SelectLinkedConnectionsComponent extends React.Component {
  static contextType = ReactReduxContext;

  constructor(props) {
    super(props);

    this.handleConnectionSelection = this.handleConnectionSelection.bind(this);
  }

  handleConnectionSelection(connection) {
    this.props.onConnectionSelection(connection);
  }

  getLinkedAccountsData(linkAccounts = []) {
    const maxVisible = 6;
    const visibleNames = linkAccounts
      .slice(0, maxVisible)
      .map(a => (a.accountMask ? `${a.accountName} - ${a.accountMask}` : a.accountName))
      .join(", ");
    const remaining = linkAccounts.length > maxVisible ? linkAccounts.length - maxVisible : 0;
    return {
      visibleNames,
      remaining
    };
  }

  render() {
    const connections = this.props.connections;

    return (
      <Container>
        <Title>{i18n.t("linkAccount.selectConnectionsTitle")}</Title>
        <Description>{i18n.t("linkAccount.selectConnectionsDescription")}</Description>
        {connections.length > 1 && (
          <DescriptionMultipleWarning>
            {i18n
              .t("linkAccount.selectConnectionsMultipleWarning")
              .replace("%count%", connections.length)
              .replace("%name%", this.props.providerName)}
          </DescriptionMultipleWarning>
        )}
        <ConnectionContainerWrapper>
          {connections.map((connection, index) => {
            const accountsData = this.getLinkedAccountsData(connection.linkAccounts);
            return (
              <ConnectionContainer key={index} onClick={e => this.handleConnectionSelection(connection)}>
                <ConnectionContainerColumnItem>{index + 1}. </ConnectionContainerColumnItem>
                <ConnectionContainerColumnItem>
                  <ConnectionTitle>
                    {connection.linkProviderName}{" "}
                    <span style={{ fontWeight: "normal" }}>via {getAggregatorName(connection.linkType)}</span>
                  </ConnectionTitle>
                  <ConnectionDescription>
                    {accountsData.visibleNames}
                    {accountsData.remaining > 0 && ` +${accountsData.remaining}`}
                  </ConnectionDescription>
                </ConnectionContainerColumnItem>
              </ConnectionContainer>
            );
          })}

          <ConnectionContainer onClick={e => this.handleConnectionSelection(null)}>
            <ConnectionContainerColumnItem>
              <ConnectionTitle>{i18n.t("linkAccount.selectConnectionsNewConnection")}</ConnectionTitle>
              <NewConnectionDescription>
                {i18n
                  .t("linkAccount.selectConnectionsNewConnectionDescription")
                  .replace("%name%", this.props.providerName)}
              </NewConnectionDescription>
            </ConnectionContainerColumnItem>
          </ConnectionContainer>
        </ConnectionContainerWrapper>
        <NoteContainer>
          <p dangerouslySetInnerHTML={{ __html: i18n.t("linkAccount.selectConnectionsNoteTitle") }} />
          <p dangerouslySetInnerHTML={{ __html: i18n.t("linkAccount.selectConnectionsNoteDescription") }} />
        </NoteContainer>
      </Container>
    );
  }
}

export default connect()(SelectLinkedConnectionsComponent);
